/**
 * @fileoverview Client-specific Dynamic Content Configuration
 *
 * This file contains configuration objects that define client-specific content
 * for the Heidrick & Struggles Leader Profile application. It enables the app
 * to display different visual elements and text content based on the client.
 *
 * The configuration includes:
 * - Header and panel images
 * - Welcome text and titles
 * - Logo images
 *
 * This approach allows for white-labeling the application without changing
 * the core functionality or requiring separate codebases for different clients.
 */

/**
 * Client-specific content configuration
 *
 * @property {Object} Hlabs - Configuration specific to Heidrick Labs client
 * @property {string} Hlabs.headerImage - Path to the header background image
 * @property {string} Hlabs.welcomeText - Welcome message with HTML support
 * @property {string} Hlabs.welcomeTextTitle - Title for the welcome section
 * @property {string} Hlabs.leftImage - Path to the left panel image
 * @property {string} Hlabs.headerLogo - Path to the header logo image
 *
 * @property {Object} * - Default configuration for all other clients
 *                       Used as fallback when a specific client config is not found
 */
export const clientInfo: any = {
  "*": {
    headerImage: "./../assets/img/backgroundLight.svg",
    welcomeText: "This platform is designed to assist leaders like you in your professional journey. Through our comprehensive assessments, we aim to provide valuable insights and help you understand various aspects of your leadership abilities.\nIf you need technical assistance, our support team is here to help by contacting <a href=mailto:support@heidrick.com>support@heidrick.com</a>.\nWe recommend that you complete each assessment section when you can be free from interruption. You may be assigned multiple assessment sections as part of this experience. Please ensure that you complete all assigned sections. Some of the measures may require advanced preparation. If this is the case, all instructions and materials are included in this portal.",
    leftImage: "./../assets/img/backgroundDark.svg",
    headerLogo: "./../assets/img/HnS-logo-default.png",
    welcomeTextTitle: "Welcome to the Leader Portal",
  },
};
